
const AuthMiddleware = () => import("@/middleware/auth");

const routeMeta = (name) => ({
  title: name.replace(/([A-Z])/g, " $1").replace(/^./, s => s.toUpperCase()).trim(),
  showChat: true,
});

export default [
  {
    path: "/:companyId/configuration",
    component: () => import("@/views/Configuration.vue"),
    beforeEnter: AuthMiddleware.user,
    children: [
      {
        path: "",
        name: "PaymentSystemConfigurationsDefault",
        component: () => import("@/components/Configuration/Payment/PaymentIntegrationsList.vue"),
        meta: routeMeta("PaymentIntegrationsList"),
      },
      {
        path: "paymentSystems",
        name: "PaymentSystemConfigurations",
        component: () => import("@/components/Configuration/Payment/PaymentIntegrationsList.vue"),
        meta: routeMeta("PaymentIntegrationsList"),
      },
      {
        path: "paymentSystems/add",
        name: "AddPaymentIntegration",
        component: () => import("@/components/Configuration/Payment/PaymentIntegrations.vue"),
        meta: routeMeta("AddPaymentIntegration"),
      },
      {
        path: "Whatsapp",
        name: "Whatsapp",
        component: () => import("@/components/Configuration/Whatsapp/WhatsApp.vue"),
        meta: routeMeta("Whatsapp"),
      },
      {
        path: "AddNewIntegration",
        name: "AddNewIntegration",
        component: () => import("@/components/Configuration/Whatsapp/AddNewIntegration.vue"),
        meta: routeMeta("AddNewIntegration"),
      },
      {
        path: "WhatsappList",
        name: "WhatsappList",
        component: () => import("@/components/Configuration/Whatsapp/WhatsappIntegrationList.vue"),
        meta: routeMeta("WhatsappList"),
      },
      {
        path: "share_point",
        name: "SharePointIntegrations",
        component: () => import("@/components/Configuration/Storage/SharePointIntegrationCredentials.vue"),
        meta: routeMeta("SharePointIntegrationCredentials"),
      },
      {
        path: "mail",
        name: "MailIntegrations",
        component: () => import("@/components/Configuration/mail_config.vue"),
        meta: routeMeta("MailConfiguration"),
      },
      {
        path: "apiIntegrations/config",
        name: "APIIntegrations",
        component: () => import("@/components/Configuration/ApiIntegrations/APIIntegrations.vue"),
        meta: routeMeta("APIIntegrations"),
      },
      {
        path: "Chatbot",
        name: "Chatbot",
        component: () => import("@/components/Configuration/ApiIntegrations/Chatbot.vue"),
        meta: routeMeta("Chatbot"),
      },
      {
        path: "Internalchat",
        name: "Internalchat",
        component: () => import("@/components/Configuration/ApiIntegrations/Internalchat.vue"),
        meta: routeMeta("Internalchat"),
      },
      {
        path: "vitel-global",
        name: "VitelGlobal",
        component: () => import("@/components/Configuration/ApiIntegrations/VitelGlobal.vue"),
        meta: routeMeta("VitelGlobal_Integration"),
      },
      {
        path: "kf-mail",
        name: "KfEmail",
        component: () => import("@/components/Configuration/ApiIntegrations/kf-email.vue"),
        meta: routeMeta("KF_mail_Integration"),
      },
    ],
  },
  {
    path: "/configuration/apiIntegrations",
    name: "ThirdPartyIntegrations",
    component: () => import("@/components/Configuration/ApiIntegrations/OAuthVerificationPage.vue"),
    beforeEnter: AuthMiddleware.user,
    meta: routeMeta("ThirdPartyIntegrations"),
  },
];
